import { Suspense, lazy } from 'react';

import { ErrorBoundary } from '@/_components';
import ErrorFallback from '@/_components/error/error-fallback';
import { Routes } from '@/_navigation';

import { Layout } from './layout';
import { Loading } from './loading';

const Page = lazy(() => import('./page'));

export function RequirementPage() {
  return (
    <Layout>
      <ErrorBoundary FallbackComponent={<ErrorFallback />}>
        <Suspense fallback={<Loading />}>
          <Page route={Routes.COLLEGE_INFO} />
        </Suspense>
      </ErrorBoundary>
    </Layout>
  );
}
